<template>
            <v-card tile>
            <v-card-title>ข้อมูลวัสดุสิ้นเปลืองเข้าระบบ</v-card-title>
            <v-divider></v-divider>
            <v-container>
                <v-form ref="form" >
                <v-row>
                    <v-col> <v-text-field disabled outlined v-model="mainData.docDate" label="วันที่ในเอกสาร"></v-text-field></v-col>
                    <v-col><v-text-field disabled outlined v-model="mainData.receiveDate" label="วันที่รับวัสดุ"></v-text-field></v-col>
                    <v-col> <v-text-field disabled outlined v-model="mainData.receiveNo" label="เลขที่ใบรับวัสดุ"></v-text-field></v-col>
                    <v-col><v-text-field disabled outlined v-model="mainData.percentDiscount" value="0" maxlength="3" v-mask="'###'"  placeholder=" " label="ส่วนลด"></v-text-field></v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-data-table
                        :headers="header"
                        :items="mainData.details"
                        style="border:0.2px solid; border-color:#909090"
                        >
                        <template v-slot:top>
                             <v-toolbar flat color="white">
                                 <v-toolbar-title>ข้อมูลวัสดุสิ้นเปลือง</v-toolbar-title>
                                 <v-divider
                                    class="mx-4"
                                    inset
                                    vertical
                                    ></v-divider>
                                    <v-spacer></v-spacer>
                             </v-toolbar>
                        </template>
                            <template v-slot:header.discount>
                                <thead>
                                    <tr>
                                        <th colspan="2" class="indigo--text text-center">ส่วนลด</th>
                                    </tr>
                                    <tr>
                                        <th class="indigo--text text-center">%</th>
                                        <th class="indigo--text text-center">ยอด</th>
                                    </tr>
                                </thead>
                            </template>

                            <template v-slot:item.discount="{item}">
                                <tr>
                                    <th class="text-center">{{item.percentDiscount}}</th>
                                    <th class="text-center">{{item.discount}}</th>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>

                 <v-row>
                    <v-col cols="6">
                        <v-data-table
                        :headers="headerSummary"
                        :items="itemSummary"
                        style="border:0.2px solid; border-color:#909090"
                        hide-default-footer
                        >
                        </v-data-table>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-col class="d-flex align-end align-right">
                        <v-btn color="primary"  @click="close">ปิด</v-btn>
                    </v-col>
                </v-row>
                </v-form>
                
            </v-container>
            
        </v-card>
</template>


<style scoped>
    .col-header {
        background: indigo;
        color: indigo;
    }
</style>

<script>


export default {
    name: 'ViewStockConsumable',
    props: ["mainData", "itemSummary"],
    data: () => ({
        header: [
            
            {text: 'หมายเลขวัสดุ', value: 'consumableCode', class: 'indigo--text'},
            {text: 'ชื่อรายการวัสดุ', value: 'consumableName', class: 'indigo--text'},
            {text: 'จำนวน', value: 'qty', class: 'indigo--text'},
            {text: 'ราคา', value: 'priceDisplay', class: 'indigo--text'},
            {text: 'ราคา/หน่วย', value: 'unitPriceDisplay', class: 'indigo--text'},
            {text: 'ยอดรวม', value: 'amountDisplay', class: 'indigo--text'},
            {text: 'ส่วนลด', value: 'discountDisplay', sortable: false, class: 'indigo--text'},
            {text: 'รวมสุทธิ', value: 'netAmountDisplay', class: 'indigo--text'}
        ],
        headerSummary: [
            {text: '', value: 'sumType'},
            {text: 'ยอดรวม', value: 'amountDisplay'},
            {text: 'ส่วนลด', value: 'discountDisplay'},
            {text: 'ราคารวมสุทธิ', value: 'netDisplay'}
        ],
        dialog: false
    }),
    methods: {
        close() {
            this.$emit("close");
        }
    }
}
</script>
